module.exports = __webpack_public_path__ + "static/media/RAR.cd4b8774.svg";